<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M5 8C5 8.26522 4.89464 8.51957 4.70711 8.70711C4.51957 8.89464 4.26522 9 4 9C3.73478 9 3.48043 8.89464 3.29289 8.70711C3.10536 8.51957 3 8.26522 3 8C3 7.73478 3.10536 7.48043 3.29289 7.29289C3.48043 7.10536 3.73478 7 4 7C4.26522 7 4.51957 7.10536 4.70711 7.29289C4.89464 7.48043 5 7.73478 5 8ZM9 8C9 8.26522 8.89464 8.51957 8.70711 8.70711C8.51957 8.89464 8.26522 9 8 9C7.73478 9 7.48043 8.89464 7.29289 8.70711C7.10536 8.51957 7 8.26522 7 8C7 7.73478 7.10536 7.48043 7.29289 7.29289C7.48043 7.10536 7.73478 7 8 7C8.26522 7 8.51957 7.10536 8.70711 7.29289C8.89464 7.48043 9 7.73478 9 8ZM12 9C12.2652 9 12.5196 8.89464 12.7071 8.70711C12.8946 8.51957 13 8.26522 13 8C13 7.73478 12.8946 7.48043 12.7071 7.29289C12.5196 7.10536 12.2652 7 12 7C11.7348 7 11.4804 7.10536 11.2929 7.29289C11.1054 7.48043 11 7.73478 11 8C11 8.26522 11.1054 8.51957 11.2929 8.70711C11.4804 8.89464 11.7348 9 12 9Z"
      :fill="color" />
    <path
      d="M2.165 15.803L2.185 15.799C4.015 15.436 5.133 14.957 5.653 14.694C6.41859 14.8982 7.20765 15.0011 8 15C12.418 15 16 11.866 16 8C16 4.134 12.418 1 8 1C3.582 1 0 4.134 0 8C0 9.76 0.743 11.37 1.97 12.6C1.88416 13.3901 1.70835 14.1678 1.446 14.918L1.443 14.929C1.36844 15.1439 1.28707 15.3563 1.199 15.566C1.12 15.752 1.273 15.96 1.472 15.928C1.70366 15.8901 1.93469 15.8484 2.165 15.803ZM2.965 12.695C2.97901 12.5486 2.96055 12.4009 2.91094 12.2625C2.86133 12.124 2.7818 11.9982 2.678 11.894C1.618 10.83 1 9.468 1 8C1 4.808 4.004 2 8 2C11.996 2 15 4.808 15 8C15 11.193 11.996 14 8 14C7.2951 14.001 6.59311 13.9096 5.912 13.728C5.67398 13.6642 5.42079 13.6906 5.201 13.802C4.814 13.998 3.961 14.372 2.567 14.695C2.76148 14.0421 2.89472 13.3726 2.965 12.695Z"
      :fill="color" />
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#71767D',
    },
    size: {
      type: Number,
      default: 12,
    },
  },
};
</script>
